import React from 'react';
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="Team Topologies by Matthew Skelton and Manuel Pais"
        desc="Organizing business and technology teams for fast flow"
        keyword="team topologies, team organization, software teams, fast flow, matthew skelton, manuel pais"
        image="/images/books/team-topologies.jpg"
        pageType="book"
        author="Matthew Skelton, Manuel Pais"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/team-topologies.jpg"
                alt="team topologies matthew skelton manuel pais engineering book"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                Team Topologies
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Matthew Skelton, Manuel Pais</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Matthew Skelton and Manuel Pais present a practical model for organizing
                technology teams around four fundamental team types — stream-aligned, platform,
                enabling, and complicated-subsystem — and three interaction modes. Rather than
                copying org charts from other companies, they show how to evolve team structures
                that optimize for fast flow of change while reducing cognitive load.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Drawing on real-world case studies and principles from Conway's Law, the book
                gives engineering leaders and individual contributors a shared language for
                discussing team design. Whether you're scaling a startup or restructuring
                a large engineering org, Team Topologies provides a blueprint for building
                teams that can deliver software quickly and sustainably.
              </p>
            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
